package com.wintermar.inspection.feature.presentation.inspection.answer.search.widget

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.badge.Badge
import com.wintermar.inspection.core.ui.component.badge.variant.BadgeSizeType
import com.wintermar.inspection.core.ui.component.badge.variant.BadgeType
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.util.toTitleCase
import com.wintermar.inspection.feature.presentation.inspection.answer.search.util.InspectionSearchQuestionType

@Composable
fun InspectionSearchResultTab(
    activeTab: InspectionSearchQuestionType,
    modifier: Modifier = Modifier,
    dimension: AppDimension = LocalAppTheme.current.dimension,
    onClick: (InspectionSearchQuestionType) -> Unit
) {

    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.spacedBy(dimension.spacing.space2)
    ) {
        InspectionSearchQuestionType.entries.forEach {
            Badge(
                type = if (activeTab == it) BadgeType.BLUE else BadgeType.GRAY,
                strong = activeTab == it,
                size = BadgeSizeType.MEDIUM,
                label = it.name.toTitleCase(),
                horizontalPadding = dimension.spacing.space4,
                clickable = true,
                onClick = {
                    onClick(it)
                }
            )
        }
    }
}
